<script setup lang="ts">
import { computed, onMounted, ref, reactive, onUnmounted, watch } from "vue";
import Header from "./Header.vue";
import Lianjie from "./Lianjie.vue";
import Scroll from "./Scroll.vue";
import Navbar from "./Navbar.vue";
import axios from "@/utils/axios";
import { useI18n } from "vue-i18n";
import { useBreadcrumbStore } from "@/stores/breadcrumb";
import { useRoute, useRouter } from "vue-router";
import logoHead from "./../../../assets/imgs/logo_head.png";
import logoHeadEn from "./../../../assets/imgs/logo_headEn.png";
const breadcrumbStore = useBreadcrumbStore();
const breadcrumbs = ref([]);
const { locale, t: $t } = useI18n();

const route = useRoute();
const router = useRouter();
const product = ref();

const productList = ref([]);
const currentIndex = ref(-1);
const ancestors = computed(() => product.value?.ancestors?.split(",") || []);
const logoSrc = computed(() => {
  return locale.value === "en" ? logoHeadEn : logoHead;
});
// 在页面加载时从localStorage恢复产品数据
onMounted(() => {
  // 如果没有产品数据，可以通过 API 重新获取
  const productId = route.params.id;
  // 添加获取产品详情的方法
  fetchProductDetail(productId);
});
watch(
  () => route.params.id,
  (newId) => {
    if (newId) {
      fetchProductDetail(newId);
    }
  }
);
const getCategoryInfo = async (brandId: string) => {
  try {
    const response = await axios.get(`/framework/category/info/${brandId}`);
    return response;
  } catch (error) {
    console.error("获取品牌信息失败:", error);
    return null;
  }
};

// 添加更新面包屑的方法
const updateBreadcrumbs = () => {
  // 先尝试从 store 获取
  let crumbs = breadcrumbStore.breadcrumbs;

  // 如果 store 中没有，则从 localStorage 获取
  if (!crumbs || crumbs.length === 0) {
    const savedCrumbs = localStorage.getItem("productBreadcrumbs");
    if (savedCrumbs) {
      crumbs = JSON.parse(savedCrumbs);
    }
  }

  // 构建面包屑
  breadcrumbs.value = [];
  // 添加已保存的面包屑
  if (crumbs && crumbs.length > 0) {
    breadcrumbs.value.push(...crumbs);
  }

  // 添加产品名称作为最后一级
  if (product.value?.translations) {
    breadcrumbs.value.push({
      title: getTranslatedText(product.value.translations, "name"),
    });
  }
};
const handleBreadcrumbClick = async (index: number) => {
  // 如果是最后一个面包屑，不做任何操作
  if (index === breadcrumbs.value.length - 1) return;

  // 获取产品的祖先路径
  const ancestors = product.value?.ancestors?.split(",");

  if (!ancestors || ancestors.length === 0) return;
  // 如果是第二层且ancestors长度大于3，不执行跳转 就是点击系统的时候不跳转
  if (index === 1 && ancestors.length > 3) return;
  console.log(index);

  // 根据层级处理跳转
  switch (index) {
    case 0: // 品牌（如"华域三电"或"上汽大众"）
      const brandInfo = await getCategoryInfo(ancestors[1]);
      router.push({
        path: "/home/product-system",
        query: {
          ...(ancestors.length > 3
            ? { systemId: ancestors[1] }
            : { menuId: ancestors[1] }),
          parentId: ancestors[0],
          systemLayout: brandInfo?.systemLayout,
        },
      });
      break;
    case 1: // 系统或分类
      const systemInfo = await getCategoryInfo(ancestors[2]);
      router.push({
        path:
          ancestors.length > 3 ? "/home/product-system" : "/home/productlist",
        query: {
          ...(ancestors.length > 3
            ? { systemId: ancestors[2] }
            : { cid: ancestors[2] }),
          parentId: ancestors[1],
          systemLayout: systemInfo?.systemLayout,
        },
      });
      break;

    case 2: // 分类或产品
      router.push({
        path: "/home/productlist",
        query: {
          cid: ancestors[3],
          parentId: ancestors[2],
        },
      });
      break;
  }
};
const getTranslatedText = (
  translations: any,
  key: string,
  defaultText: string = ""
) => {
  if (!translations) return defaultText;
  return (
    translations[locale.value]?.[key] ||
    translations["zh-cn"]?.[key] ||
    translations["en"]?.[key] ||
    defaultText
  );
};

const fetchProductDetail = async (id: string) => {
  try {
    const response = await axios.get(`/framework/product/info/${id}`);
    product.value = response;
    updateBreadcrumbs();
    // 获取到产品详情后再获取同类产品列表
    await fetchProductList();
  } catch (error) {
    console.error("获取产品详情失败:", error);
  }
};
// 获取同类产品列表
const fetchProductList = async () => {
  console.log(product.value);

  const categoryId = product.value?.ancestors?.split(",").pop();
  if (!categoryId) return;
  try {
    const response = await axios.get("/framework/product/list", {
      params: {
        limit: 999,
        page: 1,
        cid: categoryId,
      },
    });
    productList.value = response.records || [];
    currentIndex.value = productList.value.findIndex(
      (item) => item.id === route.params.id
    );
  } catch (error) {
    console.error("获取产品列表失败:", error);
  }
};
// 计算上一个和下一个产品
const prevProduct = computed(() => {
  if (currentIndex.value > 0) {
    return productList.value[currentIndex.value - 1];
  }
  return null;
});

const nextProduct = computed(() => {
  if (currentIndex.value < productList.value.length - 1) {
    return productList.value[currentIndex.value + 1];
  }
  return null;
});
const handleNavigation = (productId: string) => {
  router.push(`/home/product/${productId}`);
};
</script>
<template>
  <div v-if="product" class="product">
    <div class="main">
      <div class="kong">
        <Header></Header>
      </div>
      <!-- 添加面包屑导航 -->
      <div class="wrap_title">
        <div class="title_box">
          <div class="title">
            <a class="no" href="/">{{ $t("system.home.menu.home") }}</a>
            <template v-for="(item, index) in breadcrumbs" :key="index">
              <text class="separator">></text>
              <a
                :class="{
                  current:
                    index === breadcrumbs.length - 1 ||
                    (ancestors.length > 3 && index === 1),
                }"
                @click="handleBreadcrumbClick(index)"
                :style="{
                  cursor:
                    index === breadcrumbs.length - 1 ||
                    (ancestors.length > 3 && index === 1)
                      ? 'default'
                      : 'pointer',
                }"
              >
                {{ item.title }}
              </a>
            </template>
          </div>
        </div>
      </div>
      <section class="content">
        <div class="content_inner">
          <div class="product_item">
            <div class="product-image">
              <div class="logo-container">
                <img :src="logoSrc" alt="logo" class="corner-logo" />
              </div>
              <div class="product-image-container">
                <img :src="product.url" alt="产品图片" class="main-image" />
              </div>
            </div>
            <div class="product-details">
              <h1 class="title">
                {{ getTranslatedText(product.translations, "title") }}
              </h1>
              <div class="product-info">
                <ul class="warp">
                  <li>
                    <span class="label">{{
                      $t("system.home.product.chanpin")
                    }}</span>
                    <span class="value">{{
                      getTranslatedText(product.translations, "name")
                    }}</span>
                  </li>
                  <li v-if="product.oe">
                    <span class="label">{{
                      $t("system.home.product.oE")
                    }}</span>
                    <span class="value">{{ product.oe }}</span>
                  </li>
                  <li>
                    <span class="label">{{
                      $t("system.home.product.pinpai")
                    }}</span>
                    <span class="value">{{
                      getTranslatedText(product.translations, "bname")
                    }}</span>
                  </li>
                  <li>
                    <span class="label">{{
                      $t("system.home.product.chexing")
                    }}</span>
                    <span class="value">{{
                      getTranslatedText(product.translations, "cname")
                    }}</span>
                  </li>
                  <li class="car-type">
                    <span class="label">{{
                      $t("system.home.product.carType")
                    }}</span>
                    <span class="value">{{
                      getTranslatedText(product.translations, "carType")
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <div class="product-description">
            <div
              v-html="getTranslatedText(product.translations, 'description')"
            ></div>
          </div>
          <!-- 添加产品导航 -->
          <div class="product-navigation">
            <div
              v-if="prevProduct"
              class="arrow-btn prev"
              @click="handleNavigation(prevProduct.id)"
            >
              <i class="arrow">←</i>
            </div>
            <div
              v-if="prevProduct"
              class="nav-item prev"
              @click="handleNavigation(prevProduct.id)"
            >
              <div class="nav-content">
                <img
                  :src="prevProduct.url"
                  :alt="getTranslatedText(prevProduct.translations, 'name')"
                />
              </div>
              <div class="nav-text">
                <div class="nav-label">上一个：</div>
                <div class="nav-title">
                  {{ getTranslatedText(prevProduct.translations, "title") }}
                </div>
              </div>
            </div>
            <div
              v-if="nextProduct"
              class="nav-item next"
              @click="handleNavigation(nextProduct.id)"
            >
              <div class="nav-content">
                <img
                  :src="nextProduct.url"
                  :alt="getTranslatedText(nextProduct.translations, 'name')"
                />
              </div>
              <div class="nav-text">
                <div class="nav-label">下一个：</div>
                <div class="nav-title">
                  {{ getTranslatedText(nextProduct.translations, "title") }}
                </div>
              </div>
            </div>
            <div
              v-if="nextProduct"
              class="arrow-btn next"
              @click="handleNavigation(nextProduct.id)"
            >
              <i class="arrow">→</i>
            </div>
          </div>
        </div>
      </section>
    </div>
    <Lianjie></Lianjie>
    <Scroll v-if="$i18n.locale === 'zh-cn'"></Scroll>
    <Navbar v-if="$i18n.locale === 'en'"></Navbar>
  </div>
</template>
<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
h1 {
  margin: 0;
  padding: 0;
}
.kong {
  max-width: 1200px;
  height: 120px;
}
.product-description {
  margin-top: 100px;
  width: 80%;
}
.main {
  width: 100%;
  height: auto;
  overflow: hidden;
}
.content {
  width: 100%;
  min-height: 600px;
  padding: 40px 0;
  color: #3e3a39;
}
.content_inner {
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
  max-width: 1230px;
}
.product_item {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
}
.product-image {
  width: 50%;
  background: #eeeeee;
  position: relative;
  display: flex;
  flex-direction: column;
  min-height: 500px;

  .product-image-container {
    flex: 1; // 让容器占据剩余空间
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .main-image {
      max-width: 90%;
      max-height: 90%;
      object-fit: contain;
    }
  }
  .logo-container {
    text-align: end;
    padding: 0 20px;
    img {
      width: 100px;
      height: auto;
    }
  }
}

.product-details {
  width: 45%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.title {
  width: 100%;
  height: 32px;
  font-size: 40px;
  color: #004080;
}
.product-info {
  width: 100%;
  height: auto;
  padding-top: 40px;
}
.label {
  width: 120px;
  color: #666;
  flex-shrink: 0;
}

.value {
  flex: 1;
  padding-left: 20px;
  text-align: left;
}

ul > li {
  display: flex;
  justify-content: flex-start;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
}
span {
  width: 100%;
  height: 26px;
  font-size: 18px;
  color: #000;
  margin: 10px 0;
}
.car-type {
  display: block !important;
  border-bottom: none !important;

  .label,
  .value {
    display: block;
    width: 100%;
    padding: 4px 0;
    height: auto;
    line-height: 1.5;
  }

  .value {
    padding-left: 0;
    border-bottom: 1px solid #eee;
    padding-bottom: 8px;
    margin-bottom: 8px;
  }
}

.wrap_title {
  padding: 30px 0;
  width: 100%;
  color: #3e3a39;
  font-size: 14px;
  height: 26px;
}

.title_box {
  width: 100%;
  max-width: 1230px;
  padding: 0 15px;
  margin: 0 auto;
  box-sizing: border-box;
  .title {
    width: 100%;
    height: 100%;
    font-size: 18px;
    margin: 0 -8px;
  }
}

.title a {
  display: inline-block;
  padding: 0 8px;
  font-weight: bold;
  color: #696b71;
}
.separator {
  color: #696b71;
}
.product-navigation {
  position: relative;
  display: flex;
  justify-content: center;
  margin: 60px auto;
  max-width: 800px;
  padding: 20px 0;
}

.nav-item {
  width: 25%;
  margin: 0 20px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  transition: all 0.3s ease;

  &:hover {
    .nav-content img {
      transform: scale(1.05);
    }
    .nav-title {
      color: #004080;
    }
  }

  .nav-content {
    width: 200px;
    height: 200px;
    overflow: hidden;
    border-radius: 4px;
    margin-bottom: 5px; // 减小底部间距

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      transition: transform 0.3s ease;
    }
  }

  .nav-text {
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 0; // 移除顶部间距
  }

  .nav-label {
    font-size: 14px;
    color: #999;
    margin-bottom: 5px;
  }

  .nav-title {
    font-size: 14px;
    color: #333;
    transition: color 0.3s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }
}
.arrow-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  z-index: 1; // 添加 z-index 确保箭头在图片上层

  &:hover {
    .arrow {
      color: #004080;
    }
  }

  .arrow {
    color: #333;
    font-size: 20px;
    font-style: normal;
  }

  &.prev {
    left: 100px;
  }

  &.next {
    right: 100px;
  }
}
</style>
